import React, { Children, cloneElement, ReactElement, ReactNode } from 'react';

import classnames from 'classnames';

import { Tab } from './Tab';

interface Props<T> {
  children: ReactNode;
  className?: string;
  dontShowTabs?: boolean;
  onChangeTab?: (id: T) => void;
  selectedId: T;
}

type TabElement<T> = ReactElement<React.ComponentProps<typeof Tab<T>>>;

export const Tabs = <T extends unknown>(props: Props<T>) => {
  const handleTabClick = (newId: T) => {
    const { onChangeTab, selectedId } = props;

    if (newId === selectedId) {
      return;
    }

    if (onChangeTab) {
      onChangeTab(newId);
    }
  };

  const { children, className } = props;

  let tabContent: ReactNode = null;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore TS won't let us narrow the type from ReactChild to TabElement
  const tabs = Children.map(children, (tab: TabElement<T>) => {
    const id = tab.props.id;
    const isSelected = id === props.selectedId;

    if (isSelected) {
      tabContent = tab.props.children;
    }

    return cloneElement(tab, {
      handleTabClick,
      id: tab.props.id,
      selected: isSelected,
    });
  });

  return (
    <div className={classnames('TabbedContent', className)}>
      {!props.dontShowTabs && <div className="TabbedContent-tabs">{tabs}</div>}
      {tabContent}
    </div>
  );
};
